import { graphql } from "../generated/gql";

export const GetCall = graphql(
  `
    query GetCall($callId: ID!, $skipSentiments: Boolean!, $skipPredictedCsat: Boolean!) {
      getCall(callId: $callId) {
        ...CallDetails
        ... on ResourceNotFoundException {
          __typename
          code
          message
          resource
        }
      }
    }
  `
);
